module.exports = __webpack_public_path__ + "static/media/b2.38814a5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/v2/b2.png
// module id = 681
// module chunks = 2